import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'
import Typography from 'components/Typography'

import classes from './SectionTitle.module.scss'

/** @type {import("./types").default} */
const SectionTitle = ({ className, icon, tagline, title }) => {
  return (
    <div className={clsx('SectionTitle', classes.root, className)}>
      <Icon icon={['far', icon]} className={classes.icon} size="24" />
      <div>
        <Typography variant="heading-md" component="h3" className={classes.title}>
          {title}
        </Typography>
        {tagline && <Typography className={classes.tagline}>{tagline}</Typography>}
      </div>
    </div>
  )
}

export default SectionTitle
